module.exports = __webpack_public_path__ + "media/src/images/partners/jacobs-686474e1a76d5d57a39533093b9658bc.jpg";